/** CopyTransformModifier3D parser: the SkeletonModifier3D parse plus its `settings/<i>/` entries. */
import { boolOr, intOr } from '../../../../parser/valueParsers';
import { parseSkeletonModifier3D } from '../skeletonmodifier3d/parser';
import { newConstraintSetting, readConstraintSettings, } from '../boneconstraint3d/settings';
/** `TransformFlag::ALL` and `AxisFlag::ALL` (`copy_transform_modifier_3d.h:40-49`). */
const ALL_FLAGS = 7;
function newCopyTransformSetting() {
    return {
        ...newConstraintSetting(),
        copyFlags: ALL_FLAGS,
        axisFlags: ALL_FLAGS,
        invertFlags: 0,
        relative: true,
        additive: false,
    };
}
/** The five leaves `CopyTransformModifier3D::_set` adds (`copy_transform_modifier_3d.cpp:41-52`). */
const OWN_LEAVES = {
    copy: (setting, value, context) => {
        setting.copyFlags = intOr(value, setting.copyFlags, context);
    },
    axes: (setting, value, context) => {
        setting.axisFlags = intOr(value, setting.axisFlags, context);
    },
    invert: (setting, value, context) => {
        setting.invertFlags = intOr(value, setting.invertFlags, context);
    },
    relative: (setting, value, context) => {
        setting.relative = boolOr(value, setting.relative, context);
    },
    additive: (setting, value, context) => {
        setting.additive = boolOr(value, setting.additive, context);
    },
};
export function parseCopyTransformModifier3D(heading, properties) {
    return {
        ...parseSkeletonModifier3D(heading, properties),
        settings: readConstraintSettings(properties, newCopyTransformSetting, OWN_LEAVES),
    };
}
//# sourceMappingURL=parser.js.map